import type { AuthMeResponse } from "@/features/auth/model/auth-types"

export type WorkspaceAccessRecord = AuthMeResponse["workspaceAccess"][number]

export function resolveWorkspaceAccessRecord(
  authMe: AuthMeResponse | null | undefined,
  activeWorkspaceSlug?: string | null,
): WorkspaceAccessRecord | null {
  if (!authMe?.workspaceAccess?.length) return null

  if (activeWorkspaceSlug) {
    const exact = authMe.workspaceAccess.find((entry) => entry.workspace?.slug === activeWorkspaceSlug)
    if (exact) return exact
  }

  const active = authMe.workspaceAccess.find((entry) => entry.status === "ACTIVE")
  return active ?? authMe.workspaceAccess[0] ?? null
}
